import { useState } from 'react';

import authBg from '@/assets/images/auth-bg.jpg';
import authVideo from '@/assets/videos/auth-video-bg.mp4';

export const BackgroundVideoPlayer = () => {
  const [isVideoReady, setIsVideoReady] = useState(false);

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 h-screen w-full select-none overflow-hidden"
    >
      {/* Fallback image shown while the video loads (or if it fails to load) */}
      <img
        src={authBg}
        alt=""
        fetchPriority="high"
        className={`absolute inset-0 h-screen w-full object-cover transition-opacity duration-500 ${
          isVideoReady ? 'opacity-0' : 'opacity-100'
        }`}
      />

      {/* Background video */}
      <video
        src={authVideo}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className={`-mt-0.5 absolute inset-0 h-screen w-full object-cover transition-opacity duration-500 ${
          isVideoReady ? 'opacity-100' : 'opacity-0'
        }`}
        onCanPlay={() => setIsVideoReady(true)}
        onError={() => setIsVideoReady(false)}
      />
    </div>
  );
};
